import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  skuData: [],
  selectedSkus: [],
  defaultCountry: '',
}

export const getSkuForAttachModelSlice = createSlice({
  name: 'get-sku-for-attach-model',
  initialState,
  reducers: {
    setSkuData: (state, action) => {
      state.skuData = action.payload
    },
    setSelectedSkus: (state, action) => {
      state.selectedSkus = action.payload
    },
    setDefaultCountry: (state, action) => {
      state.defaultCountry = action.payload
    },
    reset: (state) => {
      return initialState
    },
  },
})
export const { setSkuData, setSelectedSkus, setDefaultCountry, reset } =
  getSkuForAttachModelSlice.actions
export default getSkuForAttachModelSlice.reducer
